/**
 * Usage:
 *
 * data-sw-rich-text-area
 *
 * Options:
 *
 * data-sw-rich-text-area-pre-parse="<format to parse to>"
 *
 *    Will parse html to bbcode before loading the rich text editor.
 *    Currently only accepts "bbcode" as an argument
 */
 
 var RichTextView = require('../../lib/views/RichTextView');
 var $ = require('../sw-jquery');

 module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-rich-text-area]').each(function() {
    var $el = $(this);

    new RichTextView({
      el: $el
    });
  });

};
